import $ from 'jquery';
import debug from 'bows';
import {ajaxRequest} from './_ajax';
import {trackPageview} from './_analytics';

const log = debug('microsite');

export default class {
	constructor( url ) {
		this.url = url;
		this.$nav;
		this.$links;
		this.sections = [];
		this.scrolling = false;

		this.classes = {
			microsite: 'microsite',
			header: 'microsite__header',
			nav: 'microsite-nav',
			navFixed: 'microsite-nav--fixed',
			link: 'microsite-link',
			linkActive: 'microsite-link--active',
			section: 'microsite-section',
			sectionLoaded: 'microsite-section--loaded',
			sectionLoading: 'microsite-section--loading',
			sectionLoad: 'microsite-section__load',
			back: 'microsite-back',
			backFixed: 'microsite-back--fixed'
		};

		// Reference site header
		this.header = window.site.header;

		// Disable auto-scroll to previous location
		history.scrollRestoration = 'manual';

		$().ready( this.init.bind(this) );
	}

	init() {
		// Build nav
		this.nav();

		// Scroll to section or to top
		let currentUrl = this.currentUrl();
		if ( currentUrl !== this.url ) {
			this.scrollTo( currentUrl, false );
		} else {
			// Prevent initial load mid-section
			this.scrollTo( 0, false );
		}

		// Add event listeners
		window.addEventListener( 'site.resize', this.measure.bind(this) );
		window.addEventListener( 'site.resize', this.check.bind(this) );
		window.addEventListener( 'site.scroll', this.check.bind(this) );

		// Lazy load EVERYTHING
		this.sections.forEach( ( section ) => {
			this.load( section );
		} );
	}

	nav() {
		this.$nav = $( '.' + this.classes.nav );
		this.$links = $( '.' + this.classes.link );
		this.$load = $( '.' + this.classes.sectionLoad );
		this.$back = $( '.' + this.classes.back );

		// Nav link click
		this.$links.on( 'click', ( e ) => {
			this.scrollTo( e.currentTarget.href, true );
			// Stop navigation
			e.preventDefault();
		} );

		// Load link click
		this.$load.on( 'click', ( e ) => {
			let section = this.find( e.currentTarget.href );
			this.load( section );
			// Stop navigation
			e.preventDefault();
		} );

		// Back to top click
		this.$back.on( 'click', ( e ) => {
			this.scrollTo( 0, true );
		} );
	}

	scrollTo( location, animate ) {
		log('scrollTo', location);

		// Measure before scrolling
		this.measure();

		let scrollTop;
		if ( typeof location === 'number' ) {
			scrollTop = location;
		} else if ( typeof location === 'string' ) {
			// Find section
			let section = this.find( location );
			if ( ! section ) {
				return false;
			}
			scrollTop = section.top;
		} else {
			// Unknown location
			return false;
		}

		// Set scrolling flag
		this.scrolling = true;
		this.header.disableEvents();

		// Scroll to
		if ( animate ) {
			$('html, body').animate( { scrollTop: scrollTop }, 250, 'swing', () => {
				this.scrolling = 'reset';
				this.header.resetTop();
				this.header.enableEvents();
			} );
		} else {
			window.scrollTo( 0, scrollTop );
			this.scrolling = 'reset';
			this.header.resetTop();
			this.header.enableEvents();
		}
	}

	measure() {
		log('measure');

		this.sections = [];
		$( '.' + this.classes.section ).each( ( index, section ) => {
			let $section = $( section );
			let href = $section.data('href');
			let measurements = this.measureSection( $section );

			this.sections.push( {
				$: $section,
				href: href,
				top: measurements.top,
				bottom: measurements.bottom,
				height: measurements.height
			} );

			// log({
			// 	href: href,
			// 	top: measurements.top,
			// 	bottom: measurements.bottom,
			// 	height: measurements.height
			// });
		} );
	}

	measureSection( $section ) {
		let top = Math.floor( $section.offset().top );
		let height = Math.floor( $section.height() );
		let bottom = top + height;

		return {
			top: top,
			bottom: bottom,
			height: height
		};
	}

	measureViewport() {
		let top = Math.ceil( window.pageYOffset ); // Round UP!
		let height = Math.floor( window.innerHeight );
		let bottom = top + height;

		return {
			top: top,
			bottom: bottom,
			height: height
		};
	}

	find( href ) {
		let section = this.sections.find( function ( section ) {
			return href === section.href;
		} );
		if ( ! section ) {
			return false;
		}

		return section;
	}

	currentSection() {
		let viewport = this.measureViewport();

		// Find current section (search in reverse order)
		let section = this.sections.slice().reverse().find( function ( section ) {
			return viewport.top >= section.top;
		} );

		return section;
	}

	updateSection( section ) {
		if ( true !== this.scrolling ) {
			if ( section ) {
				// Update URL to current section
				this.updateUrl( section.href );
			} else {
				// Update URL to top
				this.updateUrl( this.url );
			}
		}
	}

	updateNav( section ) {
		if ( true !== this.scrolling ) {
			if ( section ) {
				// Set link active
				this.$links
					.removeClass( this.classes.linkActive )
					.filter('[href="' + section.href + '"]')
					.addClass( this.classes.linkActive )
				;

				// Set nav fixed
				this.$nav.addClass( this.classes.navFixed );
			} else {
				// Remove link active
				this.$links.removeClass( this.classes.linkActive );

				// Remove nav fixed
				this.$nav.removeClass( this.classes.navFixed );
			}
		}
	}

	updateBack( section ) {
		if ( true !== this.scrolling ) {
			if ( section ) {
				// Set back to fixed
				this.$back.addClass( this.classes.backFixed );
			} else {
				// Remove back fixed
				this.$back.removeClass( this.classes.backFixed );
			}
		}
	}

	check() {
		// log('check');

		// Check current section
		let section = this.currentSection();
		this.updateSection( section );
		this.updateNav( section );
		this.updateBack( section );

		// Check scroll status
		this.checkScroll();
	}

	checkScroll() {
		// let viewport = this.measureViewport();
		//log('checkScroll: ' + viewport.top);

		if ( true === this.scrolling ) {
			// Do nothing
			return;
		}

		if ( 'reset' === this.scrolling ) {
			// Reset scroll position (user was scrolled via navigation)
			log('reset scrolling');
			// Reset scrolling flag
			this.scrolling = false;
			return;
		}
	}

	load( section ) {
		if ( section.$.hasClass( this.classes.sectionLoaded ) || section.$.hasClass( this.classes.sectionLoading ) ) {
			return;
		}
		log('load', section.href);

		let url = section.href;
		let $currentSection = section.$;

		$currentSection.addClass( this.classes.sectionLoading );

		let fallback = ( ) => {
			// Do nothing if unable to load
			// window.location.href = url;
		}

		ajaxRequest( {
			url: url,
			type: 'GET',
			dataType: 'html'
		}, fallback ).done( ( data ) => {
			// Convert data to fragment
			let $newSection = $( data );

			if ( ! $newSection.is( '.' + this.classes.section ) ) {
				fallback();
				return;
			}

			this.replace( $currentSection, $newSection );
		} );
	}

	replace( $currentSection, $newSection ) {
		// Viewport and section before inserting
		let currentViewport = this.measureViewport();
		let currentSection = this.measureSection( $currentSection );

		// log($newSection.data('number') + ' current top: ' + currentViewport.top);
		// log($newSection.data('number') + ' current height: ' + currentSection.height);

		// Replace current section with new section
		$currentSection.replaceWith( $newSection );

		// Content may resize as images are loaded / slider JS is applied
		// Watch for resizes for a few seconds after replacing
		let requestAnimationFrameId;
		let sectionHeight = currentSection.height;

		// Begin watching for resizes
		let checkReplacedContent = () => {
			// Viewport and section after inserting
			let newViewport = this.measureViewport();
			let newSection = this.measureSection( $newSection );

			// If the height has changed
			if ( newSection.height !== sectionHeight ) {
				// Re-measure sections
				this.measure();

				// If above the viewport
				if ( newSection.top < newViewport.top ) {
					log('fix window scroll position');

					let scrollTop = newViewport.top + ( newSection.height - sectionHeight ) + 1; // +1 for rounding issues
					this.scrollTo( scrollTop, false );
				}

				// Set sectionHeight for next time
				sectionHeight = newSection.height;
			}

			// Reset request animation frame
			requestAnimationFrameId = requestAnimationFrame && requestAnimationFrame( checkReplacedContent );
		};
		checkReplacedContent();

		// Stop checking after a few seconds
		setTimeout( () => cancelAnimationFrame && cancelAnimationFrame( requestAnimationFrameId ), 5000 );
	}

	currentUrl() {
		return window.location.protocol + '//' + window.location.host + window.location.pathname;
	}

	updateUrl( href ) {
		if ( this.currentUrl() === href ) {
			return;
		}

		log('history.replaceState', href);
		// let newUrl = href + window.location.search + window.location.hash;
		history.replaceState( {}, '', href );

		// Track pageview
		trackPageview();
	}
}
